import React from 'react';
import PropTypes from 'prop-types';
import { Context } from '../../Context';
import { withStyles } from '@material-ui/core/styles';
import { Button, Tooltip, Grid, CardActions, Card, IconButton, FormControl, TextField, FormControlLabel, FormGroup, Checkbox, CardMedia, CardContent, Typography, Divider, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@material-ui/core/';
import PostDetailsStyles from '../../Styles/PostDetailsStyles';
import { Close } from '@material-ui/icons';
import config from '../../Config/config';

class PostDetails extends React.Component {
	constructor() {
		super();
		this.state = {
			repostDialogOpen: false,
			storyDialogOpen: false,
			rejectDialogOpen: false,
			rejectFeedback: [],
			otherRejectReason: '',
			otherRejectReasonOpen: false
		};

		this.toggleRepostDialog = this.toggleRepostDialog.bind(this);
		this.toggleStoryDialog = this.toggleStoryDialog.bind(this);
		this.toggleRejectDialog = this.toggleRejectDialog.bind(this);

		this.handleRepostConfirm = this.handleRepostConfirm.bind(this);
		this.handleStoryConfirm = this.handleStoryConfirm.bind(this);
		this.handleRejectConfirm = this.handleRejectConfirm.bind(this);

		this.handleDeclineFeedback = this.handleDeclineFeedback.bind(this);
	}

	toggleRepostDialog() {
		this.setState({
			repostDialogOpen: !this.state.repostDialogOpen
		});
	}

	toggleStoryDialog() {
		this.setState({
			storyDialogOpen: !this.state.storyDialogOpen
		});
	}

	toggleRejectDialog() {
		this.setState({
			rejectDialogOpen: !this.state.rejectDialogOpen
		});
	}

	handleRepostConfirm() {
		this.props.updateAction(this.props.post.post.id, { repost: !this.props.post.repost, rejected: false });
		this.toggleRepostDialog();
	}

	handleStoryConfirm() {
		this.props.updateAction(this.props.post.post.id, { makeStory: !this.props.post.makeStory, rejected: false });
		this.toggleStoryDialog();
	}

	handleRejectConfirm() {
		// need to include the other feedback
		const newRejectFeedback = this.state.rejectFeedback.concat(this.state.otherRejectReason);

		this.props.updateAction(this.props.post.post.id, {
			rejected: true,
			rejectFeedback: newRejectFeedback
		});
		this.toggleRejectDialog();
	}

	handleOtherRejectReasonText = event => {
		//const newRejectFeedback = this.state.rejectFeedback.concat(event.target.value);
		this.setState({
			otherRejectReason: event.target.value
		});
	};

	handleDeclineFeedback(event, feedback) {
		let newRejectFeedback = [];

		if (event.target.checked) {
			newRejectFeedback = this.state.rejectFeedback.concat(feedback);
		} else {
			newRejectFeedback = this.state.rejectFeedback.filter((f) => f !== feedback);
		}
		this.setState({
			rejectFeedback: newRejectFeedback
		});

		console.log('newRejectFeedback', newRejectFeedback, feedback);

		if (feedback === 'Other (please tell us more?)') {
			this.setState({ otherRejectReasonOpen: true });
		}
	}

	render() {
		const { classes } = this.props;
		const { post } = this.props;
		let priceRange = '7-10';

		if (post.ownerFollowers > 999) {
			const minPrice = parseInt(post.ownerFollowers * 0.6 * config.PRICE / 1000);
			const maxPrice = parseInt(post.ownerFollowers * config.PRICE / 1000);

			priceRange = `${minPrice}-${maxPrice}`;
		}

		return (
			<div>
				<Card className={classes.card}>
					{!post.rejected && (
						<Tooltip title='This will reject the post for the current campaign'>
							<IconButton aria-label="Delete" className={classes.icon} onClick={this.toggleRejectDialog}>
								<Close fontSize="small" />
							</IconButton>
						</Tooltip>
					)}
					<img alt="Instagram logo" className={classes.logo} src='https://storage.googleapis.com/vimma/ig_logo_40px.png' />
					<a href={`https://www.instagram.com/p/${post.post.shortcode}`} target='_blank' rel="noopener noreferrer">
						<CardMedia
							className={classes.media}
							image={post.post.thumbnail_src}
							title="Instagram Post"
						/>
					</a>
					<CardContent>
						<Tooltip title='This is the estimated price range for reposting and story. It will never exceed the maximum.'>
							<Typography gutterBottom variant="h5" component="h2">
								£{priceRange}
							</Typography>
						</Tooltip>
						{post.ownerFollowers > 999 ? (
							<Typography variant="body2" >
								{(post.ownerFollowers / 1000).toFixed(1)}K followers
          					</Typography>
						) : (
								<Typography variant="body2" >
									{'<1K followers'}
								</Typography>
							)}
						{post.action === 'Repost' && (
							<Typography variant="body2" >
								Post is approved for reposting
          					</Typography>
						)}
						{post.action === 'Make a story' && (
							<Typography variant="body2" >
								Post is approved for making a story
          					</Typography>
						)}
					</CardContent>
					<Divider />
					{this.props.showActions && (
						<CardActions>
							<Grid
								container
								spacing={0}
								direction='row'
								justify='flex-end'>
								<Grid item>
									<Tooltip title='Select this influencer for the campaign'>
										<Button color='primary' variant='contained' onClick={this.toggleRepostDialog}>
											Approve
									</Button>
									</Tooltip>
								</Grid>
							</Grid>
						</CardActions>)}
				</Card>
				<Dialog
					maxWidth="sm"
					aria-labelledby="confirmation-dialog-title"
					disableBackdropClick
					disableEscapeKeyDown
					open={this.state.repostDialogOpen}
				>
					<DialogTitle id="repost-confirmation-dialog-title">
						{post.repost ? 'Cancel reposting?' : 'Approve this creator?'}

					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{post.repost ? 'This will cancel the reposting of this post. You can always ammend this later.' : 'This creator will be selected for your campaign. You can always undo this later.'}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.toggleRepostDialog}>
							Cancel
          				</Button>
						<Button onClick={this.handleRepostConfirm} color="primary" variant='contained'>
							Accept
          				</Button>
					</DialogActions>
				</Dialog>
				<Dialog
					maxWidth="sm"
					aria-labelledby="confirmation-dialog-title"
					open={this.state.storyDialogOpen}
				>
					<DialogTitle id="story-confirmation-dialog-title">
						{post.makeStory ? 'Cancel making a story?' : 'Approve for making a story?'}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{post.makeStory ? 'This will cancel making a story. You can always ammend this later.' : 'This post will be made a story from the influencer\'s account with the campaign details as you specified.'}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.toggleStoryDialog}>
							Cancel
          				</Button>
						<Button onClick={this.handleStoryConfirm} color="primary">
							Accept
          				</Button>
					</DialogActions>
				</Dialog>
				<Dialog
					maxWidth="sm"
					aria-labelledby="confirmation-dialog-title"
					open={this.state.rejectDialogOpen}
				>
					<DialogTitle id="story-confirmation-dialog-title">Are you sure you want to remove this creator from your campaign?</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Before you confirm, please give us feedback so we can serve your brand better in the future:
            			</DialogContentText>
					</DialogContent>
					<DialogContent>
						<FormControl>
							<FormGroup >
								<FormControlLabel
									control={
										<Checkbox
											onChange={(event) => this.handleDeclineFeedback(event, 'Creator does not fit the desired demographics')}
											color="primary"
										/>
									}
									label='Creator does not fit the desired demographics'
								/>
								<FormControlLabel
									control={
										<Checkbox
											onChange={(event) => this.handleDeclineFeedback(event, 'Creator’s content is not up to standards')}
											color="primary"
										/>
									}
									label="Creator’s content is not up to standards"
								/>
								<FormControlLabel
									control={
										<Checkbox
											onChange={(event) => this.handleDeclineFeedback(event, 'Creator does not fit the brand')}
											color="primary"
										/>
									}
									label="Creator does not fit the brand"
								/>
								<FormControlLabel
									control={
										<Checkbox
											onChange={(event) => this.handleDeclineFeedback(event, 'Other (please tell us more?)')}
											color="primary"
										/>
									}
									label="Other (please tell us more?)"
								/>
							</FormGroup>
						</FormControl>
					</DialogContent>
					{this.state.otherRejectReasonOpen && (<DialogContent>
						<TextField
							label="Other reason"
							value={this.state.otherRejectReason}
							onChange={this.handleOtherRejectReasonText}
							fullWidth
							margin="normal"
							variant="outlined"
							multiline={true}
							rows={2}
							required={true}
							helperText='Please enter your reason for rejecting this creator'
						/>
					</DialogContent>)}
					<DialogActions>
						<Button onClick={this.toggleRejectDialog}>
							Cancel
          				</Button>
						<Button onClick={this.handleRejectConfirm} color="primary">
							Accept
          				</Button>
					</DialogActions>
				</Dialog>
			</div >
		);
	}
}

PostDetails.propTypes = {
	classes: PropTypes.object.isRequired
};

PostDetails.contextType = Context;

export default withStyles(PostDetailsStyles)(PostDetails);
